import React from 'react'
import { Outlet } from "react-router-dom";
import Header from "./Header"
import Sidebar from "./Sidebar"

const AdminLayout = () => {
    return ( 
        <>
            <Header/>
            <Sidebar/>
            <main className='main' id="main">
                <Outlet/>
            </main>
        </>
     );
}
  
export default AdminLayout;